import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import { map, uniq } from 'lodash';

const initialState = {
  indexIds: [],
};

const indexIds = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.indexIds;
  }
  switch (type) {
    case types.GET_CART_REQUEST_SUCCESS:
      let series = map(payload.entities.models, model => {
        return model.seriesId;
      });
      return uniq(series);
    case types.GET_ADDITIONAL_CART_REQUEST_SUCCESS:
      let inCartSeries = map(payload.entities.models, model => {
        return model.seriesId;
      });
      return uniq(state.concat(inCartSeries));
    case types.GET_CART_REQUEST_FAILURE:
      return initialState.indexIds;
    default:
      return state;
  }
};

export default combineReducers({
  indexIds,
});
